import { Cta } from './Cta';
import { Submit } from './Submit';

export const Buttons = {
  Cta,
  Submit,
};
